import Vue from 'vue'
import Vuex from 'vuex'
import IconList from './iconslist.js'
import attachCognitoModule from '@vuetify/vuex-cognito-module'
import methods from './textappymethods'
const UserPool = 'us-west-2_3d3JID60G' //18Panels userpool
const IdPool = 'us-west-2:298bb257-e38c-4729-a20e-e7f803403933'
const App = 'textappyio'
Vue.use(Vuex)
//4u6rfdvfq2i8enb78sm8t9f1l
const set = property => (store, payload) => (store[property] = payload)

const store = new Vuex.Store({
  state: {
    url: (process.env.NODE_ENV === 'development') ? 'http://localhost:3002/' : 'https://api.18panels.com/',
    dev: (process.env.NODE_ENV === 'development'),
    icons: IconList,
    //stripe client for 18panels users editors
    stripeClient: (process.env.NODE_ENV === 'development') ? 'pk_test_LdlO17GauZaC9PlbmKeavr6q' : 'pk_live_iv1VpOJUjQLIEIuBAqHO9zH7',
    sportcode:'beach',
    email: '',
    isLoading: false,
    isReady: false,
    loggedin:false,
    password: '',
    color1:'indigo',
    color2:'indigo',
    coloron:'green darken-1',
    snackbar: {},
    appdata:false,
    org:undefined,
    myorgs:[],
    usage:{},
    notifications:false,
    contacts:false,
    activecontact:false,
    editcontact:false,
    groups:false,
    archivedgroups:[],
    activegroup:false,
    contactcount:{},
    contactduplicates:{},
    selectedgroups:[],
    rules:{
      nameRules: v => { if(v) { return (v === v ) || 'Name' } else return true },
      emailRules: v => { if(v) { return /.+@.+\..+/.test(v) || 'E-mail must be valid' } else {return true} },
      cellRules: v => { if(v) { return (v && v.length === 10) || '10 digit cell phone format' } else {return true}},
      required: v => !!v || 'Required'
    },
    customer:undefined,
    products:undefined,
    plans:undefined,
    sentitems:[],
    sentitemlimits:{
      a:0,
      b:30
    },
    activesentrecord:false,
    version:'...',
    newcontent:false,
    contactinfoschema: {
      cell: undefined,
      email: undefined,
      emailverified:false,
      id: undefined,
      name: undefined,
      updatedAt: undefined,
      uuid: undefined,
      nickname: undefined,
      customeid: undefined,
      status: undefined
    },
    idpool: IdPool,
    userpool: UserPool,
    permissions:[],
    user: undefined,
    events:[],
    //deprecate
    eventheaders: [
      {
        text: '',
        align: 'start',
        sortable: false,
        value: 'imgurl',
      },
      {
        text: 'Name',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Active',
        value:'active'
      },
      {
        text:'Show',
        value:'show'
      },
      {
        text: 'Date',
        value: 'createdAt'
      }
    ],
    videoprogress: undefined,
    newcontactcount: 0,
    socialnetworks: [
      {type:'Facebook',icon:'mdi-facebook-box'},
      {type:'Instagram',icon:'mdi-instagram'},
      {type:'Twitter',icon:'mdi-twitter-box'},
      {type:'Youtube',icon:'mdi-youtube'},
      {type:'Linkedin',icon:'mdi-linkedin-box'},
      {type:'Pinterest',icon:'mdi-pinterest-box'}
    ],
    groupstatus: 'groups',
    activeevent: undefined,
    newinvoicedialog: false,
    myplayers: undefined,
    message: ''
  },
  mutations: {
    setNewContactCount: set('newcontactcount'),
    setEmail: set('email'),
    setIsReady: set('isReady'),
    setIsLoading: set('isLoading'),
    setLoggedIn: set('loggedin'),
    setPassword: set('password'),
    setSnackbar: set('snackbar'),
    setAppData: set('appdata'),
    setUsage: set('usage'),
    setOrg: set('org'),
    setMyOrgs: set('myorgs'),
    setContacts: set('contacts'),
    setGroups: set('groups'),
    setCustomer: set('customer'),
    setProducts: set('products'),
    setPlans: set('plans'),
    setArchivedGroups: set('archivedgroups'),
    setGroupsContactsCount:set('contactcount'),
    setActiveGroup: set('activegroup'),
    setActiveContact: set('activecontact'),
    setEditContact: set('editcontact'),
    setSentItems: set('sentitems'),
    setActiveSentRecord: set('activesentrecord'),
    setVersion: set('version'),
    setPermissions: set('permissions'),
    setNewContent: set('newcontent'),
    setEvents: set('events'),
    setNtfs: set('notifications'),
    resetVideoProgress: set('videoprogress'),
    setActiveEvent: set('activeevent'),
    setNewInvoiceDialog: set('newinvoicedialog'),
    setMyPlayers: set('myplayers'),
    setMessage: set('message'),
    setVideoProgress (state, p) {
      Vue.set(state.videoprogress, p.key, p.value)
    },
    setSelectedGroups(state,data){
      console.log('DATA:', data)
      state.selectedgroups = data;
      if(data.length===0){
        state.contactcount = {}
        state.contactduplicates = {}
        return;
      }
      let gps = {}
      let duplicates = {}
      data.forEach(async g=>{
        console.log(g)
        let gc = await store.dispatch('getGroup',g.groupkey);
        console.log(gc)
        let contacts = Object.values(gc.Item.contacts);
        let keys = Object.keys(gps)
        contacts.forEach(c=>{
          if(keys.includes(c.uuid)){
            duplicates[c.uuid] = c
          }
          gps[c.uuid] = c
          state.contactcount = gps;
          state.contactduplicates = duplicates
        })
      })
    },
    appendContact(state,data){
      let s = state.contacts
      let item = state.contacts.find(item => item.uuid === data.uuid);
      if(item===undefined){
        s.unshift(data);
        store.commit('setContacts',s)
      } else {
        Object.assign(item, data);
      }
      store.dispatch('getNewContactCount')
    },
    removeContact(state,data){
      let i = state.contacts.findIndex(f=>{return f.uuid === data.uuid})
      state.contacts.splice(i,1)
    },
    updateContact(state,data){
      //filter/forEach would also work. but for loop allows us to break;
      let ln = state.contacts.length;
      for(let i=0;i<ln;i++){
        let c = state.contacts[i]
        if(c.id===data.id){
          Vue.set(state.contacts, i, data)
          break;
        }
      }

    },
    updateGroup(state,data){
      console.log(data)
      let index = state.groups.findIndex(f=>{return f.groupkey === data.sortkey})
      console.log(index)
      Vue.set(state.groups,index,data)
    },
    appendGroup(state,data){
      console.log(data)
      state.groups.unshift(data)
    },
    removeGroup(state,data){
      let index = state.groups.findIndex(f=>{return f.sortkey === data.sortkey})
      state.groups.splice(index,1)
      window.localStorage.setItem('groups', JSON.stringify(state.groups))
    },
    removeArchivedGroup(state,data){
      Vue.delete(state.archivedgroups, [data.sortkey])
    },
    activeGroupStatus: set('groupstatus')
  },

  actions: {
    async post (state, data) {
      let session = await store.dispatch('cognito/fetchSession');
      let orgkey = (store.state.org)?store.state.org.partkey:false
      return new Promise((resolve, reject) => {
        let options = {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + session.accessToken.jwtToken,
            'Pool': UserPool,
            'Org': orgkey,
            'Orgkey': orgkey,
            'App':App
          },
          body: JSON.stringify(data.body)
        }

        fetch(store.state.url + data.path, options)
            .then((response) => response.json())
            .then((response) => {
              if(response.error && response.error.code){
                store.commit('setSnackbar',{
                  type: response.error.status,
                  msg: response.error.message,
                  timeout:5000
                })
              }
              resolve(response)
            }).catch(error=>{
          store.commit('setSnackbar',{
            type: error.error.status,
            msg: error.error.message,
            timeout:5000
          })
          reject(error)
        })
      })
    },


    async fetch (state, args) {
      let session = await store.dispatch('cognito/fetchSession');
      let orgkey = (store.state.org)?store.state.org.partkey:false
      let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + session.accessToken.jwtToken,
        'Pool': UserPool,
        'Org': orgkey,
        'Orgkey': orgkey,
        'App':App
      }
      let data = args.data
      let options = {}
      return new Promise((resolve, reject) => {
        if (args.method == 'GET') {
          options = {
            method: args.method,
            headers: headers
          }
        } else {
          options = {
            method: args.method,
            headers: headers,
            body: JSON.stringify(data)
          }
        }
        let c = {
          '400':'warning'
        }
        fetch(args.url, options)
            .then((response) => response.json())
            .then((response) => {
              if(response.error && response.error.code){
                store.commit('setSnackbar',{
                  type: response.error.status,
                  msg: response.error.message,
                  timeout:5000
                })
              }
              resolve(response)
            }).catch(error=>{
              store.commit('setSnackbar',{
                type: error.error.status,
                msg: error.error.message,
                timeout:5000
              })
              reject(error)
        })
      })
    },


    async put (state, data) {
      let session = await store.dispatch('cognito/fetchSession');
      let orgkey = (store.state.org)?store.state.org.partkey:false
      return new Promise((resolve, reject) => {
        let options = {
          method: 'PUT',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + session.accessToken.jwtToken,
            'Pool': UserPool,
            'Org': orgkey,
            'Orgkey': orgkey,
            'App':App
          },
          body: JSON.stringify(data.body)
        }
        let c = {
          '400':'warning'
        }

        fetch(store.state.url + data.path, options)
            .then((response) => response.json())
            .then((response) => {
              if(response.error && response.error.code){
                store.commit('setSnackbar',{
                  type: response.error.status,
                  msg: response.error.message,
                  timeout:5000
                })
              }
              resolve(response)
            }).catch(error=>{
          store.commit('setSnackbar',{
            type: error.error.status,
            msg: error.error.message,
            timeout:5000
          })
          reject(error)
        })
      })
    },


    async get (state, data) {
      let session = await store.dispatch('cognito/fetchSession');
      let orgkey = (store.state.org)?store.state.org.partkey:false
      return new Promise((resolve, reject) => {
        let options = {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + session.accessToken.jwtToken,
            'Pool': UserPool,
            'Org': orgkey,
            'Orgkey': orgkey,
            'App':App
          }
        }
        let c = {
          '400':'warning'
        }

        fetch(store.state.url + data.path, options)
            .then((response) => response.json())
            .then((response) => {
              if(response.error && response.error.code){
                store.commit('setSnackbar',{
                  type: response.error.status||'warning',
                  msg: response.error.message,
                  timeout:5000
                })
              }
              resolve(response)
            }).catch(error=>{
                // store.commit('setSnackbar', {
                //   type: error.error.status,
                //   msg: error.error.message,
                //   timeout: 5000
                // })
          reject(error)
        })
      })
    },


    async delete (state, data) {
      let session = await store.dispatch('cognito/fetchSession');
      let orgkey = (store.state.org)?store.state.org.partkey:false
      return new Promise((resolve, reject) => {
        let options = {
          method: 'DELETE',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + session.accessToken.jwtToken,
            'Pool': UserPool,
            'Org': orgkey,
            'Orgkey': orgkey,
            'App':App
          },
          body: JSON.stringify(data.body)
        }
        let c = {
          '400':'warning'
        }

        fetch(store.state.url + data.path, options)
            .then((response) => response.json())
            .then((response) => {
              if(response.error && response.error.code){
                store.commit('setSnackbar',{
                  type: response.error.statu,
                  msg: response.error.message,
                  timeout:5000
                })
              }
              resolve(response)
            }).catch(error=>{ console.log(error)
          store.commit('setSnackbar',{
            type: error.error.status,
            msg: error.error.message,
            timeout:5000
          })
          reject(error)
        })
      })
    },


    async openFetch (state, args) {
      let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Pool': UserPool,
        'App':App
      }
      let data = args.data
      let options = {}
      return new Promise((resolve, reject) => {
        if (args.method == 'GET') {
          options = {
            method: args.method,
            headers: headers
          }
        } else {
          options = {
            method: args.method,
            headers: headers,
            body: JSON.stringify(data)
          }
        }
        fetch(args.url, options)
            .then((response) => response.json())
            .then((response) => {
              resolve(response)
            })
      }, error => {
        reject(error)
      })
    },


    async openGet (state, args) {
      let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Pool': UserPool,
        'App':App
      }
      let options = {}
      return new Promise((resolve, reject) => {
        options = {
          method: 'GET',
          headers: headers
        }
        fetch(args.url, options)
            .then((response) => response.json())
            .then((response) => {
              resolve(response)
            })
      }, error => {
        reject(error)
      })
    },




    refreshAuth(){
      console.log('RefreshingAuth')
      store.dispatch('cognito/fetchSession')
          // .then(data=>{})
          .finally(() => {
            store.commit('setIsReady', true)
            if (!store.getters['cognito/isLoggedIn']){
              console.log('Refreshing auth')
              store.commit('setLoggedIn',false)
              return;
            }
            store.commit('setLoggedIn',true)
            store.dispatch('getAppData')
          })
    },


    async getAppData () {
      let args = {
        url: store.state.url + 'api/auth/authrecordv2',
        method: 'GET'
      }
      store.dispatch('fetch', args)
          .then(function (response) {
            console.log(response)
            store.commit('setNtfs',response.permissions)
            store.dispatch('putAppOrg',response)
            if(response.org===false){
              /**/
            } else {
              //methods.Contacts.getAll(store)
              store.dispatch('getContacts')
              store.dispatch('getAllActiveGroups')
            }
          })
          .catch(function (e) {
            console.log(e)
          })
    },


    putAppOrg (state,data) {
      let nts = data.appdata.notifications ||  []
      if(!data.org){
        nts.push({code:"apporg",text:"Set up your App/Organization",icon:"fas fa-exclamation",to:"/account/organization"})
      }
      if(data.appdata && data.appdata.notifications){
        store.commit('setNtfs',nts)
      }
      if(data.org){
        store.commit('setOrg',data.org)
        store.commit('setMyOrgs',Object.values(data.appdata.orgs))
        store.commit('setPermissions',data.permissions)
      }
      if(data.appdata){
        store.commit('setAppData',data.appdata)
        store.commit('setMyOrgs',Object.values(data.appdata.orgs))
      }
    },

    getActiveGroups(){
      methods.Groups.getAll(store)
    },

    async getGroup(state,groupkey){
      let g = await methods.Groups.get(store,groupkey)
      store.commit('setActiveGroup',g.Item)
      return g
    },

    async removeFromGroup(state, d){
      let data = {
        groupkey:d.groupkey,
        contactuuid:d.contactuuid,
        orgpartkey: store.state.org.partkey
      }
      let args = {
        url:store.state.url + 'api/groups/removefromgroupv2',
        method:"POST",
        data:data
      }
      let res = await store.dispatch('fetch',args).then(res => {
        return res
      });
      return res
    },

    getContacts(){
      methods.Contacts.getAll(store)
    },

    getNewContactCount(){
      let nc = store.state.contacts.filter(f=>{return f.status==='new'}).length
      store.commit('setNewContactCount',nc)
    },

    async newContact(){
      // let c = await store.dispatch('get',{path: 'api/contacts/blank'})
      let c = {
        info: {
          uuid: undefined,
          name: '',
          nickname:'',
          email: '',
          cell: '',
          instagram: ''
        }
      }
      store.commit('setActiveContact',c)
      store.commit('setEditContact', true)
    },

    async getContact(state,uuid){
      return await store.dispatch('get',{path: 'api/contacts/contactv2/' + uuid})
    },

    async getActiveContact(state,uuid){
      if(!uuid)return  store.commit('setActiveContact',false)
      let c = await methods.Contacts.getContact(store,uuid);
      store.commit('setActiveContact',c)
    },

    signout () {
      store.dispatch('cognito/signOut');
      store.commit('setAppData',{})
      store.commit('setContacts',false)
      store.commit('setGroups',false)
      store.commit('setMyOrgs', [])
      store.commit('setOrg',undefined);
      window.localStorage.removeItem('groups')
      window.location.reload()
    },

    async getSentItems () {
      let args;
      args = {
        url:store.state.url + 'api/sendsms/sentitemsbyorgname',
        method:"POST",
        data:{
          a:store.state.sentitemlimits.a,
          b:store.state.sentitemlimits.b
        }
      }
      store.dispatch('fetch',args).then(d=>{
        store.commit('setSentItems', d)
      })
    },

    async getCustomer() {
      let args = {
        url: store.state.url + 'api/payments/stripe18panels/customer',
        method: 'GET'
      }
      store.dispatch('fetch', args)
          .then(function (response) {
            console.log(response)
            if (response === null || response.error) {
              //IMPORTANT - 'false' = NO CUSTOMER RECORD THROUGH STRIPE YET.
              store.commit('setCustomer',false)
            } else {
              store.commit('setCustomer',response)
            }
          }).catch(e => {
            console.log(e)
            store.commit('setCustomer',false)
      })
    },

    async getProducts() {
      let em = this;
      let args = {
        url: store.state.url + 'api/payments/stripe18panels/textappyproducts',
        method: 'GET'
      }
      store.dispatch('fetch', args)
          .then(function (response) {
            if(response.length > 0){
              store.commit('setProducts',response)
              store.dispatch('getPlans')
            } else {
              store.commit('setProducts',false)
              store.commit('setPlans',false)
            }
          }).catch(function (e) {
          em.creatingcustomer = false;
        console.log(e)
      })
    },

    async getPlans() {
      let em = this;
      let args = {
        url: store.state.url + 'api/payments/stripe18panels/textappyplans',
        method: 'GET'
      }
      store.dispatch('fetch', args)
          .then(function (response) {
            let plans = response
            plans.sort((a,b)=>(a.amount<b.amount)?1:-1)
            store.commit('setPlans',plans)
          }).catch(function (e) {
        em.creatingcustomer = false;
        console.log(e)
      })
    },

    getAllActiveGroups(){
      let args = {
        url: store.state.url + 'api/groups/getByStatusv3/1',
        method:"GET"
      }
      store.dispatch('fetch',args)
          .then((res)=>{
            console.log(res)
            store.commit('setGroups', res)
            window.localStorage.setItem('groups', JSON.stringify(res))
          }).catch(e=> {return e} );

    },

    getAllArchivedGroups(){
      let args = {
        url: store.state.url + 'api/groups/getByStatusv3/0',
        method:"GET"
      }
      store.dispatch('fetch',args).then(res=>{
        console.log(res)
        store.commit('setArchivedGroups',res)
      }).catch(e=>{
        return e
      })
    },

    removeNtfs(state,item){
      let n = store.state.notifications;
      if(typeof n === 'boolean') {
        return
      } else {
        n = store.state.notifications.splice(0)
      }
      if(n.length===1){
        store.commit('setNtfs',false)
      } else {
        let index = n.findIndex(f=>{return f.code === item.code})
        let data = n.splice(index,1)
        store.commit('setNtfs',data)
      }

    },

    reLoad(){
      window.location.reload(true)
    },

    async getUuid(){
      //will get a unique uuid from our server, prevents overwrite
      // (because node is singlethreaded, it wont create dupes)
      return await store.dispatch('get',{path: 'uuid'})
    },

    async getEvents() {
      let data = await store.dispatch('get',{path:'api/payments/stripegeneralusers/events/' + store.state.org.partkey})
      //not used yet
      store.commit('setEvents',data)
    },

    async  getEvent(s,id) {
      let data = await store.dispatch('get',{path: 'api/event/json/'+id})
      if(data.error)return
      store.commit('setActiveEvent', data)
    },

    async getDivisions(s,data) {
      let dd = await store.dispatch('get',{path:'api/tournament/divisions/'+data.eventid})
      return dd
    },

    checkPermissions(store,data){
      if(data.permissions.length<1)return false
      if(data.permissions.includes('*'))return true
      let test = false
      // data.permissions = ['financial','contacts']
      // data.required = ['financial']
      test = data.required.every(function(r){
        return data.permissions.includes(r)
      })
      return test
    },

    // getPlayer(key){
    //   let em = this;
    //   let args = {
    //     url: Store.state.url+'api/player/p/'+key+'/'+Store.state.club.sportcode,
    //     method:'GET',
    //     data:{
    //       sport:Store.state.club.sportcode
    //     }
    //   }
    //   Store.dispatch('fetch',args)
    //     .then(function(data){ //returns data.item OR false
    //       Store.commit('activeplayer', data);
    //     }).catch(function(e){
    //     console.log(e);
    //   });
    // }

  }
})

attachCognitoModule(store, {
  userPoolId: UserPool, // "us-west-2_BIoxoV41w",
  identityPoolId: IdPool, // "us-west-2:ce5b44ad-0218-45dd-82db-d05f8494680d",
  userPoolWebClientId: "4u6rfdvfq2i8enb78sm8t9f1l", // "nee14h00vjtd1sukjljr9uu63",
  region: "us-west-2"
}, 'cognito')

store.dispatch('refreshAuth')

export default store
